import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Alert, Button, Row, Col } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import {
  formItemLayout,
  renderInput
} from '../../shared/utils/form_components';
import { required } from '../../shared/utils/form_validations';


class CatalogForm extends Component {
  render() {
    const { handleSubmit, deleteError, error, submitting, deleteButton } = this.props;
    const err = deleteError || error;

    return (
      <Form layout="horizontal" onSubmit={handleSubmit}>

        <Row>
          <Col lg={18} xs={24}>

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to="/raffles">Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="submit"
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Form.Item
              {...formItemLayout}
              label="Name"
              required
            >
              <Row>
                <Col>
                  <Field
                    inputOnly
                    name="name"
                    placeholder="Name"
                    component={renderInput}
                    validate={required}
                  />
                </Col>
              </Row>

            </Form.Item>

            <Form.Item
              {...formItemLayout}
              label="Logo URL"
            >
              <Row>
                <Col>
                  <Field
                    inputOnly
                    name="logo"
                    placeholder="url"
                    component={renderInput}
                  />
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'CatalogForm',
})(CatalogForm);
